import { AxiosResponse } from 'axios';
import { PagedResponse } from '@types_main/paged-response';
import { PagedParams } from '@types_main/paged.params';
import { BaseService } from '../../../../../services/route.service';
import { CloseLeadScheduleRequest, LeadScheduleRequest } from './requests/lead-schedule.request';
import { AgendaItemResponse, LeadScheduleResponse } from './responses/lead-schedule.response';

export class CrmScheduleService extends BaseService {
    protected get resourceName(): string {
        return 'crm/lead-schedules';
    }

    public async getAll(
        filter?: string,
        params?: PagedParams
    ): Promise<AxiosResponse<PagedResponse<LeadScheduleResponse>>> {
        return await this.get(`by-lead/${filter}`, params);
    }

    /// Compromissos do intervalo mostrado na grade; sem userId, a agenda da equipe inteira.
    public async agenda(
        from: string,
        to: string,
        userId?: string
    ): Promise<AxiosResponse<{ data: AgendaItemResponse[] }>> {
        return await this.get('agenda', userId ? { from, to, userId } : { from, to });
    }

    public async create(
        body: LeadScheduleRequest
    ): Promise<AxiosResponse<{ data: LeadScheduleResponse }>> {
        return await this.post(body);
    }

    /// Corrige o texto e a hora de uma ação aberta.
    public async update(
        id: string,
        body: { description: string; scheduledAt: string }
    ): Promise<AxiosResponse<{ data: LeadScheduleResponse }>> {
        return await this.put(id, body);
    }

    public async close(
        id: string,
        body: CloseLeadScheduleRequest
    ): Promise<AxiosResponse<LeadScheduleResponse>> {
        return await this.patch(`${id}/close`, body);
    }
}
